import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import CarouselSection from '@/pages/home/components/CarouselSection';
import CardsSection from '@/pages/home/components/CardsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import MediaSection from '@/pages/home/components/MediaSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import ContactSection from '@/pages/home/components/ContactSection';
import IndexSection from '@/pages/home/components/IndexSection';
import AboutSection from '@/pages/home/components/AboutSection';
import AppSection from '@/pages/home/components/AppSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary-500 focus:text-background-50 focus:rounded-lg">
        跳转到主要内容
      </a>

      <Header />

      <main id="main-content">
        <Hero />
        <CarouselSection />
        <CardsSection />
        <FaqSection />
        <MediaSection />
        <CommentsSection />
        <RankingSection />
        <ContactSection />
        <IndexSection />
        <AboutSection />
        <AppSection />
        <FeaturesSection />
        <UpdatesSection />
        <TopicsSection />
      </main>

      <Footer />
    </div>
  );
}